import type { StoreAppTheme } from '@/shared/utils/store-theme';
import type { QuantityPromotionRule } from '@/shared/utils/quantity-promotion';

export const ENDPOINT = 'api/app/merchants';

export type MerchantScheduleTime = {
  open: string;
  close: string;
  day: string;
};

export type MerchantScheduleData = {
  monday?: MerchantScheduleTime[];
  tuesday?: MerchantScheduleTime[];
  wednesday?: MerchantScheduleTime[];
  thursday?: MerchantScheduleTime[];
  friday?: MerchantScheduleTime[];
  saturday?: MerchantScheduleTime[];
  sunday?: MerchantScheduleTime[];
};

export type MerchantAddress = {
  street: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
};

export type MerchantGeo = {
  latitude: string;
  longitude: string;
};

export type MerchantLocation = {
  address: MerchantAddress;
  geo: MerchantGeo;
};

export type MerchantOrderPrice = {
  min: string;
  max: string;
};

export type MerchantDeliveryTime = {
  min: number;
  max: number;
};

export type MerchantContact = {
  cnpj: string | null;
  phone: string;
  instagram: string | null;
  whatsapp: string;
  facebook: string | null;
};

export type MerchantAnalytics = {
  meta_pixel_id: string | null;
  google_tag_manager_id: string | null;
};

export type MerchantDetails = {
  id: string;
  slug: string;
  name: string;
  description: string;
  is_open: boolean;
  distance: number;
  image: string;
  cover: string;
  rating: string | null; // null quando a loja não exibe avaliações (PRAT-44)
  rating_count?: number; // avaliações dos últimos 30 dias (base da média `rating`)
  reviews_enabled?: boolean; // PRAT-44: false = loja não exibe avaliações (ausente na API antiga)
  delivery_type: number; // 1=delivery, 2=pickup, 3=both
  schedule_data: MerchantScheduleData;
  location: MerchantLocation;
  order_price: MerchantOrderPrice;
  delivery_time: MerchantDeliveryTime | null;
  preparation_time: number | null; // tempo de preparo/retirada em minutos; null quando indisponível
  delivery_charge: number;
  pickup_discount_percent: number; // percentual de desconto para pedidos de retirada (0–100); 0 quando não há desconto
  pickup_discount_percentage: number; // nome real do campo em /details: percentual de desconto de retirada (0–100); 0 quando não há desconto
  min_order_price: string;
  contact: MerchantContact;
  analytics: MerchantAnalytics;
  delivers_to_address: boolean | null; // null = não verificado, true = entrega, false = não entrega
  loyalty_enabled: boolean; // true quando a loja participa do Clube PratiGO
  app_theme?: StoreAppTheme | null; // cores do app escolhidas no gestor (PRAT-154); null = padrão pratiGO
  quantity_promotion?: QuantityPromotionRule | null; // promoção por quantidade (PRAT-184); null = sem promoção
  ordering_enabled?: boolean; // PRATDEV-260: false = cardápio só vitrine (sem sacola nem checkout); ausente = compra ligada
};

export type GetMerchantDetailsRequest = {
  slug: string;
  latitude?: string;
  longitude?: string;
};

export type GetMerchantDetailsResponse = MerchantDetails;
